<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>SE CONNECTER</h2>
                    <ul>
                        <li><a routerLink="/">ACCUEIL</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>SE CONNECTER</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="login-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="login-container">
                    <div class="row g-0">
                        <!-- Colonne de gauche avec image et texte explicatif -->
                        <div class="col-lg-6 d-none d-lg-block">
                            <div class="login-hero">
                                <div class="hero-image">
                                    <img src="./assets/img/upload/home/section-1.png" alt="Connexion BSTP" />
                                </div>
                                <div class="hero-overlay">
                                    <div class="hero-content">
                                        <div class="hero-badge">
                                            <i class="icofont-shield"></i>
                                            <span>Sécurisé</span>
                                        </div>
                                        <h2>Bienvenue sur BSTP Guinée</h2>
                                        <p>Connectez-vous pour accéder à votre espace entreprise et gérer vos activités professionnelles.</p>
                                        
                                        <div class="features-list">
                                            <div class="feature-item">
                                                <i class="icofont-check-circled"></i>
                                                <span>Vos informations d'entreprise</span>
                                            </div>
                                            <div class="feature-item">
                                                <i class="icofont-check-circled"></i>
                                                <span>Vos demandes d'appels d'offres</span>
                                            </div>
                                            <div class="feature-item">
                                                <i class="icofont-check-circled"></i>
                                                <span>Vos documents et certifications</span>
                                            </div>
                                            <div class="feature-item">
                                                <i class="icofont-check-circled"></i>
                                                <span>Votre suivi de progression</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Colonne de droite avec le formulaire -->
                        <div class="col-lg-6">
                            <div class="login-form-wrapper">
                                <div class="form-header">
                                    <div class="logo-section">
                                        <div class="logo-icon">
                                            <i class="icofont-users"></i>
                                        </div>
                                        <h1>Connexion Entreprise</h1>
                                        <p>Veuillez saisir vos identifiants pour vous connecter</p>
                                    </div>
                                </div>
                                
                                <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
                                    <div class="form-group">
                                        <label for="username" class="form-label">
                                            <i class="icofont-email"></i>
                                            Adresse électronique
                                        </label>
                                        <input
                                            class="form-control"
                                            type="username"
                                            formControlName="username"
                                            placeholder="Saisissez votre email"
                                            aria-label="Adresse email"
                                        />
                                    </div>
                                    
                                    <div class="form-group">
                                        <label for="password" class="form-label">
                                            <i class="icofont-lock"></i>
                                            Mot de passe
                                        </label>
                                        <div class="password-input">
                                            <input
                                                class="form-control"
                                                [type]="showPassword ? 'text' : 'password'" 
                                                formControlName="password"
                                                placeholder="Saisissez votre mot de passe"
                                                aria-label="Mot de passe"
                                                autocomplete="current-password"
                                            />
                                            <button 
                                                type="button"
                                                class="password-toggle" 
                                                (click)="showPasswordFunction()"
                                                aria-label="Afficher/Masquer le mot de passe">
                                                <i [class]="showPassword ? 'icofont-eye' : 'icofont-eye-blocked'"></i>
                                            </button>
                                        </div>
                                        <div class="forgot-password">
                                            <a routerLink="/forgot-password">Mot de passe oublié?</a>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label">
                                            <i class="icofont-shield"></i>
                                            Vérification de sécurité
                                        </label>
                                        <re-captcha
                                            class="w-100"
                                            id="recaptcha"
                                            formControlName="recaptcha"
                                        ></re-captcha>
                                    </div>

                                    <div class="form-actions">
                                        <button type="submit" class="btn btn-primary" [disabled]="form.invalid || loading">
                                            <i class="icofont-login"></i>
                                            <span>SE CONNECTER</span>
                                            <div class="loading-spinner" *ngIf="loading">
                                                <i class="icofont-spinner-alt-1"></i>
                                            </div>
                                        </button>
                                    </div>
                                    
                                    <div class="form-footer">
                                        <p>N'avez-vous pas encore de compte?
                                            <a routerLink="/create-account" class="">
                                                <i class="icofont-user-plus"></i>
                                                S'enregistrer ici
                                            </a>
                                        </p>
                                        
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>